export class ListWithUpdates<T> {
  constructor(readonly state: T[],
              readonly added: T[] = [],
              readonly removed: T[] = [],
              readonly updated: T[] = [],
  ) {}
}
